import { ANALYTICS_CATEGORIES } from 'Services/analytics/analytics.const';

import { basePaymentsEvent } from './base/basePaymentEvent';
import type { PaymentEventProps } from './base/basePaymentEvent.type';

const {
	PAYMENTS: { MOTORWAY_PAY_MODULR },
} = ANALYTICS_CATEGORIES;

export function motorwayPayModulrEvents<CustomData extends UnknownShapeObject>(
	props: PaymentEventProps<CustomData>,
): void {
	basePaymentsEvent({
		category: MOTORWAY_PAY_MODULR,
		...props,
	});
}
